"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.PublicPurchaseService = void 0;
var PublicPurchaseService = /** @class */ (function () {
    function PublicPurchaseService() {
    }
    return PublicPurchaseService;
}());
exports.PublicPurchaseService = PublicPurchaseService;
//# sourceMappingURL=purchase.js.map